import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  FormModal,
  Layout,
  Reminder,
  ReminderGroup,
  ShowMoreButton,
  Skeleton,
} from "./components";
import { formatGroupName, groupReminders, size, split } from "./helper";

export function Container({
  loading,
  numOfFetches,
  data,
  firstName,
  lastName,
  showAll,
  onShowMore,
  onNavigate,
  onReschedule,
  onCompleteTask,
  onDismiss,
}) {
  const splitByShowAll = (d) => {
    return showAll ? [d, {}] : Object.entries(d).reduce(split(2, 2), [{}, {}]);
  };
  const [reminderGroups, hiddenGroups] = splitByShowAll(groupReminders(data));
  const [reminderWithTask, setReminderWithTask] = useState(null);

  return (
    <React.Fragment>
      <Layout data-test="card-reminders">
        <Layout.Header>
          <Layout.Icon spinning={loading}>
            Upcoming Reminders
            {numOfFetches > 0 && ` (${data.length})`}
          </Layout.Icon>
        </Layout.Header>
        <Layout.Body>
          {loading && numOfFetches === 0 && <Skeleton />}

          {numOfFetches > 0 && data.length === 0 && (
            <div
              style={{ color: "grey", marginLeft: "1em", paddingBottom: "1em" }}
            >
              {firstName || lastName || "The client"}
              &nbsp;has no upcoming reminders.
            </div>
          )}

          {numOfFetches > 0 && data.length > 0 && (
            <React.Fragment>
              <div
                style={showAll ? {} : { display: "flex", flexDirection: "row" }}
              >
                {Object.entries(reminderGroups).map(
                  ([dateGroup, reminderGroup]) => {
                    return (
                      <ReminderGroup
                        key={dateGroup}
                        collapsed={!showAll}
                        title={formatGroupName(dateGroup)}
                      >
                        {reminderGroup.map((r) => {
                          return (
                            <Reminder
                              key={r.id}
                              data={r}
                              onNavigate={onNavigate}
                              onReschedule={onReschedule}
                              onCompleteTask={(reminder) => {
                                return reminder.task.formInstanceId &&
                                  !reminder.task.formInstance?.isFilled
                                  ? setReminderWithTask(r)
                                  : onCompleteTask(r);
                              }}
                              onDismiss={onDismiss}
                            />
                          );
                        })}
                      </ReminderGroup>
                    );
                  }
                )}
              </div>
              <ShowMoreButton
                onClick={onShowMore}
                visiable={showAll || size(hiddenGroups) > 0}
              >
                {showAll
                  ? "Minimize"
                  : `Show more (${size(hiddenGroups)} hidden)`}
              </ShowMoreButton>
            </React.Fragment>
          )}
        </Layout.Body>
      </Layout>
      {reminderWithTask && (
        <FormModal
          formId={reminderWithTask.task.formInstanceId}
          onClose={() => {
            setReminderWithTask(null);
          }}
          onDone={() => {
            onCompleteTask(reminderWithTask, () => {
              setReminderWithTask(null);
            });
          }}
        />
      )}
    </React.Fragment>
  );
}

Container.propTypes = {
  loading: PropTypes.bool.isRequired,
  numOfFetches: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  showAll: PropTypes.bool.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onShowMore: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  onReschedule: PropTypes.func.isRequired,
  onCompleteTask: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

Container.defaultProps = {
  firstName: undefined,
  lastName: undefined,
};

export default Container;
